import PropTypes from 'prop-types'
import { Dialog, ProgressCircle, Center } from '@chakra-ui/react'

export const CircularProgressModal = ({ isOpen = true }) => (
  <Dialog.Root open={isOpen}>
    <Dialog.Backdrop />
    <Dialog.Positioner display="flex" alignItems="center" justifyContent="center">
      <Dialog.Content bg="transparent" boxShadow="none">
        <Center h={'100%'}>
          <ProgressCircle.Root value={null} size="lg">
            <ProgressCircle.Circle css={{ '--thickness': '3px' }}>
              <ProgressCircle.Track stroke="gray.600" />
              <ProgressCircle.Range stroke="white" />
            </ProgressCircle.Circle>
          </ProgressCircle.Root>
        </Center>
      </Dialog.Content>
    </Dialog.Positioner>
  </Dialog.Root>
)

CircularProgressModal.propTypes = {
  isOpen: PropTypes.bool,
}
